module.exports = __webpack_public_path__ + "img/go.9f6e52ec.svg";